import { render } from "./CreateChecklistDialog.vue?vue&type=template&id=0fa6571c&scoped=true"
import script from "./CreateChecklistDialog.vue?vue&type=script&lang=js"
export * from "./CreateChecklistDialog.vue?vue&type=script&lang=js"

import "./CreateChecklistDialog.vue?vue&type=style&index=0&id=0fa6571c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa6571c"]])

export default __exports__